export enum CoreConstants {
  SeatNumber = 'seatNumber',
  SelectedTableType = 'selectedTableType',
}
export enum NestedNavPages {
  SETTINGS_NICKNAME_CHANGE = 'SETTINGS_NICKNAME_CHANGE',
}

export enum ScreenNameConstants {
  SCREEN_NAME_MIN_LENGTH = '2',
  SCREEN_NAME_MAX_LENGTH = '20',
}
